/*
 * Admin Model - For SessionApi to handle response of `sign_in` method which returns the signed in Admin
 *
 */

export class Admin {
  id: number;
  name: string;
  email: string;

  constructor(id: number, name: string, email: string) {
    this.id = id;
    this.name = name;
    this.email = email;
  }
}